(function () {
	const simpleSlider = () => {
		$(".simple-slider-section").each(function () {
			if ($(this).hasClass("slider_started")) {
				return "";
			}
			$(this).addClass("slider_started");
			const id = $(this).attr("id");
			const box = $(this).find(".simple-slider");
			const autoplay = box.data("autoplay");
			const stopAutoplay = box.data("stop-autoplay");
			const delay = box.data("delay") * 1000;
			const perRow = parseInt(box.data("per-row")) || 1;
			// Transition speed (2026-10-20): a speed of 0 in the section settings
			// made every slide change jump instantly. 0 or empty now falls back to
			// 0.8s so slides always glide.
			const speed = (Number(box.data("speed")) || 0.8) * 1000;
			let autoplayParm = {};
			if (autoplay) {
				autoplayParm = {
					autoplay: {
						delay: delay,
						pauseOnMouseEnter: stopAutoplay,
						disableOnInteraction: false,
					},
				};
			}
			let swiperParms = {
				effect: box.data("effect"),
				speed: speed,
				slidesPerView: 1,
				spaceBetween: 10,
				breakpoints: {
					750: {
						slidesPerView: perRow,
						spaceBetween: 16,
					},
				},
				autoHeight: false,
				calculateHeight: false,
				keyboard: true,
				// Touch swipe, mouse drag and horizontal trackpad / wheel
				// scrolling (2026-10-15), together with the arrows and dots.
				allowTouchMove: true,
				simulateTouch: true,
				grabCursor: true,
				threshold: 5,
				mousewheel: { forceToAxis: true, sensitivity: 1, releaseOnEdges: true },
				navigation: {
					nextEl: `#${id} .swiper-button-next`,
					prevEl: `#${id} .swiper-button-prev`,
				},
				pagination: {
					el: `#${id} .swiper-pagination`,
					clickable: true,
				},
				...autoplayParm,
			};
			const swiper = new Swiper(`#${id} .swiper`, swiperParms);
		});
	};

	document.addEventListener("DOMContentLoaded", function () {
		simpleSlider();
		document.addEventListener("shopify:section:load", function () {
			simpleSlider();
		});
	});
})();
